(function () {
	'use strict';
	angular.module('app.core')
		.controller('globalItemSearchCtrl', globalItemSearchCtrl);

	globalItemSearchCtrl.$inject = ['$scope', '$rootScope', '$timeout', '$state', '$http', 'globalItemFilterFunctionsService', 'storeService'];

	function globalItemSearchCtrl($scope, $rootScope, $timeout, $state, $http, globalItemFilterFunctionsService, storeService) {
		var vm = this;
		var tempResults = [];
		var tempSearchPhrase = '';
		var previousSiteString = '';
		var useTempResults = false;
		var dontShowTypeahead = false;
		var typeaheadTriggerInProgress = false;
		
		var searchTooltipPromise;
		var searchTransitionPromise;
		
		$scope.typeahead = {};
		$scope.typeahead.searchPhrase = '';
		$scope.typeahead.loading = false;
		$scope.typeahead.noResults = false;
		$scope.typeahead.showDropdown = false;
		$timeout(function () { // wait for template to load
			// Typeahead default positioning does not play along well with css transition, so we need to set left position manually
			setTypeaheadDropdownPosition();
			window.addEventListener('resize', setTypeaheadDropdownPosition);
		});
		$scope.typeahead.debounceTime = 200;
		$scope.typeaheadFocus = { 
			triggerOnFocus: false,
			triggerOnClick: false
		};
		$scope.filterFunctions = globalItemFilterFunctionsService;

		vm.showClearButton = true;
		vm.searchOpen = false;
		vm.filterVisible = $scope.filterFunctions.filterList.length > 1;
		vm.searchTooltipProperties = {};
		vm.searchTooltipOpen = false;
		vm.filterButtonTooltipOpen = false;
		vm.filterButtonTooltipEnabled = false;
		
		// functions
		vm.clearText = clearText;
		vm.closeSearchOnEsc = closeSearchOnEsc;
		vm.closeFilterOnEsc = closeFilterOnEsc;
		vm.getItems = getItems;
		vm.onFilterButtonTooltipMouseEnter = onFilterButtonTooltipMouseEnter;
		vm.onFilterButtonTooltipMouseLeave = onFilterButtonTooltipMouseLeave;
		vm.onFilterDropdownToggle = onFilterDropdownToggle;
		vm.onTypeaheadBlur = hideTypeaheadDropdown;
		vm.onTypeaheadChange = showOrHideTypeaheadDropdown;
		vm.showSearch = showSearch;
		vm.searchTooltipStart = searchTooltipStart;
		vm.searchTooltipEnd = searchTooltipEnd;
		vm.selectItem = selectItem;
		
		function clearText() {
			$scope.typeahead.searchPhrase = '';
			hideTypeaheadDropdown();
			$scope.typeahead.loading = false;
			document.querySelector('.global-item-search').focus();
		}

		function closeSearch() {
			vm.filterButtonTooltipOpen = false;
			vm.filterButtonTooltipEnabled = false;
			vm.searchOpen = false;
			hideTypeaheadDropdown();
		}

		function closeSearchOnEsc(e) {
			if (e.key === 'Escape' || e.key === 'Esc') {
				e.stopPropagation();
				closeSearch();
				document.querySelector('#global-item-search-icon').focus();	
			}
			if (e.key === 'Tab') {
				hideTypeaheadDropdown();
			}
		}

		function closeFilterOnEsc(e) {
			if (e.key === 'Escape' || e.key === 'Esc') {
				e.stopPropagation();
				var typeaheadInputEl = document.querySelector('#global-item-search');
				typeaheadInputEl.click();
			}
		}

		function getItems(input) {
			if (useTempResults && input === tempSearchPhrase) {
				useTempResults = false;
				return new Promise (function (resolve, reject) {
					$timeout(function () {
						resolve(tempResults);
					});
				});;
			}
			$scope.typeahead.noResults = false;
			var factoryIdList = $scope.filterFunctions.getFactoryList();
			var url = '/api/2/factndx/' + factoryIdList + '/ItemSearch';
			var body = { 
				operation: 'rows',
				columns: [],
				filters: [],
				paging: {
					start: 0,
					limit: 10
				},
				extraParams: {
					search: input,
					typeahead: true
				}
			};

			tempSearchPhrase = input;
			return $http.post(url, body, { ignoreLoadingBar: true })
				.then(function (response) {
					var items = response.data && response.data.data;
					if (items && items.length) {
						items = items
							.map(function (item) {
								var factory = $scope.filterFunctions.filterList.find(function (factory) {
									return factory.id === item.factoryNdx;
								});
								var factoryName = factory && factory.name;
								return Object.assign({ 
									site: factoryName
								}, item);
							});
						if (items.length > 1) {
							items.push({
								itemNdx: 'viewAllResults',
								itemDescription: 'View all results for "<strong>' + input + '</strong>"',
								site: ''
							});
						}
					} else {
						var trimmedZeroInput = input.replace(/^0+/, '');
						$scope.typeahead.noResults = true && trimmedZeroInput.length >= 3;
						items = [];
					}
					tempResults = items;
					return items;
				})
				.catch(function (e) {
					$rootScope.$emit('toast', {
						'message': 'Unexpected Server Error',
						'success': false
					});
				});
		}

		function hideOnOutsideClick(event) {
			var filterDropdownOpen = $scope.filterFunctions.getViewValues().visibleMenu === 'site';
			if (filterDropdownOpen || !vm.searchOpen) return;
			var globalItemSearch = document.querySelector('global-item-search');
			var multiSelectMenuAncestor = $(event.target).closest('.multiselect-menu')[0];
			var isInFilterDropdown = multiSelectMenuAncestor && multiSelectMenuAncestor.getAttribute('filter-id') === 'site';
			if (isInFilterDropdown || globalItemSearch.contains(event.target)) return;
			closeSearch();
			$scope.$apply();
		}

		function onFilterButtonTooltipMouseEnter() {
			if (vm.filterButtonTooltipEnabled) vm.filterButtonTooltipOpen = true;
		}

		function onFilterButtonTooltipMouseLeave() {
			vm.filterButtonTooltipOpen = false;
		}

		function onFilterDropdownToggle(open) {
			if (open) {
				vm.filterButtonTooltipEnabled = false;
				vm.filterButtonTooltipOpen = false;
				previousSiteString = $scope.filterFunctions.getViewValues().displayName;
				hideTypeaheadDropdown();
				$scope.filterFunctions.setOpen(true);
			}
			if (!open) {
				vm.filterButtonTooltipEnabled = true;
				var typeaheadInputEl = document.querySelector('#global-item-search');
				var typeaheadInputModel = angular.element(typeaheadInputEl).controller('ngModel');
				if (previousSiteString === $scope.filterFunctions.getFactoryListString()) {
					useTempResults = true;
				}
				if ($scope.typeahead.searchPhrase && $scope.typeahead.searchPhrase.length >= 1) {
					$scope.typeaheadFocus.triggerOnFocus = true;
					typeaheadTriggerInProgress = true;
					typeaheadInputModel.$options.debounce =  { default: 0 }; // don't debounce typeahead-focus directive
					$timeout(function () {
						typeaheadTriggerInProgress = false;
						typeaheadInputModel.$options.debounce =  { default: 200 }; // restore normal debounce
					}); // wait for typeahead-focus directive to trigger getItems
				}
				$scope.filterFunctions.cancelSelection();
				showOrHideTypeaheadDropdown($scope.typeahead.searchPhrase);
				document.querySelector('#global-item-search').focus();
			}
		}

		function searchTooltipStart() {
			if (searchTooltipPromise) $timeout.cancel(searchTooltipPromise);
			if (vm.searchOpen) return;
			searchTooltipPromise = $timeout(function () {
				if (!vm.searchOpen) vm.searchTooltipOpen = true;
			}, 500);
		}

		function searchTooltipEnd() {
			vm.searchTooltipOpen = false;
			if (searchTooltipPromise) $timeout.cancel(searchTooltipPromise);
		}
		
		function selectItem(item) {
			$scope.typeahead.searchPhrase = tempSearchPhrase;
			closeSearch();
			if (item.itemNdx === 'viewAllResults') {
				var selectedFactories = $scope.filterFunctions.getFactoryList();
				if (selectedFactories.split(',').length === $scope.filterFunctions.filterList.length) {
					selectedFactories = 'LDNA_A_S';
				}
				$state.go('app.supply-chain.item-search', {
					search: $scope.typeahead.searchPhrase,
					sites: selectedFactories
				});
				return;
			}

			storeService.dispatch(storeService.actionCreators.modal.openItemDrilldownAction({
				itemCode: item.itemCode,
				factoryNdx: item.factoryNdx,
				defaultTab: 'supplyAndDemandSection',
				exactMatch: true,
				itemNdx: item.itemNdx
			}));
		}

		function setTypeaheadDropdownPosition() {
			var globalItemSearch = document.querySelector('.global-item-search');
			if (!globalItemSearch) return;
			var globalSearchRect = globalItemSearch.getBoundingClientRect();
			$scope.typeahead.dropdownRight = window.innerWidth - globalSearchRect.right;	
			$scope.typeahead.dropdownTop = globalSearchRect.bottom;	
		}

		function showSearch() {
			if (vm.searhVisible) return;
			if (searchTooltipPromise) $timeout.cancel(searchTooltipPromise);
			if (searchTooltipPromise) $timeout.cancel(searchTransitionPromise);
			// hide pendo resource center guide when search is opened
			pendo && pendo.hideGuides && pendo.hideGuides();
			vm.filterButtonTooltipEnabled = false;
			var typeaheadInputEl = document.querySelector('#global-item-search');
			var typeaheadInputModel = angular.element(typeaheadInputEl).controller('ngModel');
			if ($scope.typeahead.searchPhrase && $scope.typeahead.searchPhrase.length >= 1) {
				$scope.typeaheadFocus.triggerOnFocus = true;
				useTempResults = true;
				dontShowTypeahead = true;
				typeaheadTriggerInProgress = true;
				typeaheadInputModel.$options.debounce =  { default: 0 };
				$timeout(function () {
					typeaheadTriggerInProgress = false;
					typeaheadInputModel.$options.debounce =  { default: 200 };
				}); // wait for typeahead-focus directive to trigger getItems
			}

			searchTransitionPromise = $timeout(function () {
				showOrHideDropdownAfterTransition();
				vm.filterButtonTooltipEnabled = true;
			}, 400); 
	
			vm.searchTooltipOpen = false;
			document.addEventListener('click', hideOnOutsideClick);
			typeaheadInputEl.select();
			vm.searchOpen = true;
		};

		function showOrHideDropdownAfterTransition() {
			dontShowTypeahead = false;
			showOrHideTypeaheadDropdown($scope.typeahead.searchPhrase);
		}

		function showTypeaheadDropdown() {
			$scope.typeahead.showDropdown = true;
		}

		function hideTypeaheadDropdown() {
			$scope.typeahead.showDropdown = false;
		}

		function showOrHideTypeaheadDropdown(inputText) {
			if (dontShowTypeahead) return;
			$scope.typeahead.searchPhrase = inputText;
			if (inputText && inputText.length >= 1) {
				showTypeaheadDropdown();
			} else {
				if (typeaheadTriggerInProgress) return;
				$scope.typeahead.noResults = false;
				hideTypeaheadDropdown();
			}
		}

		$scope.$on('$destroy', function () {
			document.removeEventListener('click', hideOnOutsideClick);
			window.removeEventListener('resize', setTypeaheadDropdownPosition);
			if (searchTooltipPromise) $timeout.cancel(searchTooltipPromise);
			if (searchTransitionPromise) $timeout.cancel(searchTransitionPromise);
		});
	}
})();
